
import SourcePopover from './source-popover.vue'

export default {
  components: {SourcePopover},
  inject: ['di_sources'],
  props: {
    num: {
      type: Number, required: true
    },
    disabled: {
      type: Boolean, default: false
    }
  },
  data(){
    return {
      popup_visible: false
    }
  },
  computed: {
    source(){
      return this.di_sources[this.num - 1]
    }
  }
}
